import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const NURSERYTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.NurseryType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const NURSERYTYPE_CONFIG = {
  entityName: 'NurseryType',
  localizationKey: 'Planning::Entity.NurseryType',
  fields: NURSERYTYPE_FIELDS,
  permission: 'PlanningLocation.NurseryTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
